<div *ngIf="isDebugEnabled" class="debug" [ngClass]="{ show: isDebugEnabled }">
  <a class="close-link" (click)="toggleDebugConsole()">Close</a>
  <pre><ng-content></ng-content></pre>
</div>
<button
  *ngIf="!isDebugEnabled"
  mat-flat-button
  color="primary"
  class="btn-debug console"
  (click)="toggleDebugConsole()"
>
  CONSOLE
</button>
<button *ngIf="!isDebugEnabled" mat-flat-button color="primary" class="btn-debug debugger" (click)="debug()">
  DEBUG
</button>
